module.exports = __webpack_public_path__ + "static/media/settings-icon-active.91499566.svg";